export default class NavigationMobile {

  constructor(selector) {
    const triggers = once('navigation-mobile', document.querySelector(selector))

    if (triggers.length) {
      this.trigger = triggers.shift();
      this.body = document.querySelector('body');
      this.content = document.querySelector('.navigation--mobile-wrapper');
      this.active = false;

      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.clickHandler();
      });
    }
  }


  clickHandler() {
    this.active = !this.active

    // if (this.active) {
    //   window.scrollTo(0, 0);
    // }

    this.body.classList.toggle('navigation--mobile__active', this.active);
    this.trigger.setAttribute('aria-expanded', this.active)
    this.trigger.setAttribute('aria-label', this.active ? 'Navigation ausblenden' : 'Navigation einblenden');
    this.content.setAttribute('aria-hidden', !this.active);
  }

}
